/*
 ********************************************************************************************************************************
 *    Module:                   : Reducer                                                                                           *
 *    Description:              : Main reducer that keeps entire global states		      											  				    				  			*
 *
 *                                                                                                                              *
 *                            Maintenance Log                                                                                   *
 *                                                                                                                              *
 ********************************************************************************************************************************
 *  DATE               : Developer                                : Description of Change                                       *
 
 *  2023-12-07         : Vinoth                                    : Contains every global state values                                      *
 * ******************************************************************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  toastMessage: {
    severity: "",
    message: "",
    messageStatus: false,
  },
  defaultcompany: "",
  userFullName: "",
  userId: "",
  token: "",
  defaulttenant: "",
  db: "",
  tenantId: "",
  tenantID: "",
  accessList: [],
  
  // Tour states
  tourRun: false,
  isTourEnabled: true,
  tourStatusLoaded: false,
  activeTour: null,
  completedTours: {},
  tourStepIndex: 0,
};

const mainSlice = createSlice({
  name: "main",
  initialState,
  reducers: {
    setToastMessage: (state, action) => {
      state["toastMessage"] = {
        severity: action?.payload?.severity,
        message: action?.payload?.message,
        messageStatus: action?.payload?.messageStatus,
      };
    },

    setUserData: (state, action) => {
      // ✅ Handle variations in field names between login and scan-data APIs
      state["userId"] = action?.payload?.userId || action?.payload?.userID || action?.payload?.sessionUserID || state["userId"];
      state["userFullName"] = action?.payload?.userFullName || action?.payload?.sessionUsername || action?.payload?.fullname || state["userFullName"];
      state["defaultcompany"] = action?.payload?.defaultcompany || action?.payload?.sessionCompanyDefaultID || action?.payload?.defaultCompany || state["defaultcompany"];
      state["defaulttenant"] = action?.payload?.defaulttenant || state["defaulttenant"];
      state["token"] = action?.payload?.token || state["token"];
      state["db"] = action?.payload?.db || state["db"];
      state["tenantId"] = action?.payload?.tenantId || action?.payload?.tenantID || state["tenantId"];
      state["tenantID"] = action?.payload?.tenantID || action?.payload?.tenantId || state["tenantID"];
      
      if (action?.payload?.tenantEnabled !== undefined) {
        state["tenantEnabled"] = action.payload.tenantEnabled;
      }

      // Store the user's granular permission list
      if (action?.payload?.accessList) {
        state["accessList"] = action.payload.accessList;
      }
    },

    setTourRun: (state, action) => {
      state.tourRun = action.payload;
    },
    setTourEnabled: (state, action) => {
      state.isTourEnabled = action.payload;
    },
    startTour: (state, action) => {
      state.activeTour = action.payload;
      state.tourRun = true;
      state.tourStepIndex = 0;
    },
    stopTour: (state) => {
      state.tourRun = false;
      state.activeTour = null;
      state.tourStepIndex = 0;
    },
    completeTour: (state, action) => {
      const tourName = action.payload;
      state.completedTours = { ...state.completedTours, [tourName]: true };
      state.tourRun = false;
      state.activeTour = null;
      state.tourStepIndex = 0;
    },
    setTourStepIndex: (state, action) => {
      state.tourStepIndex = action.payload;
    },
    setTourData: (state, action) => {
      if (action.payload.completedTours !== undefined) {
        state.completedTours = action.payload.completedTours;
      }
      if (action.payload.isTourEnabled !== undefined) {
        state.isTourEnabled = action.payload.isTourEnabled;
      }
      state.tourStatusLoaded = true;
    },
    resetTourState: (state) => {
      state.tourRun = false;
      state.isTourEnabled = true;
      state.tourStatusLoaded = false;
      state.activeTour = null;
      state.completedTours = {};
      state.tourStepIndex = 0;
    },
  },
});

export const { 
  setToastMessage, 
  setUserData,
  setTourRun,
  setTourEnabled,
  startTour,
  stopTour,
  completeTour,
  setTourStepIndex,
  setTourData,
  resetTourState
} = mainSlice?.actions;

export default mainSlice?.reducer;
